import { Component, Input, OnInit } from "@angular/core";

import { Observable } from "rxjs";
import { select, Store } from "@ngrx/store";
import {
  AppState,
  loadedProfessionalFuelTotalizerState,
  loadedProfessionalFuelTotalState,
} from "src/app/store/reducers";

import { ProfessionalFuelTotalizerDTO } from "src/app/models/ProfessionalFuel/professionalFuelDTO";

@Component({
  selector: "chip-list",
  templateUrl: "./chip-list.component.html",
  styleUrls: ["./chip-list.component.scss"],
})
export class ChipListComponent {
  totalizer$: Observable<ProfessionalFuelTotalizerDTO>;
  _totalizer: ProfessionalFuelTotalizerDTO;
  total$: Observable<number>;
  _total: number = 0;

  //Professional Fuel Totalizers
  totalErrors: number = 0;
  totalWarnings: number = 0;
  totalOkay: number = 0;

  @Input() set totalizer(value) {
    this.totalizer$ = this.store.pipe(
      select(loadedProfessionalFuelTotalizerState)
    );
    this.total$ = this.store.pipe(select(loadedProfessionalFuelTotalState));
    this.totalizer$.subscribe((totalizers) => {
      if (totalizers) {
        this._totalizer = totalizers;
        this.totalOkay = 0;
        this.totalWarnings = 0;
        this.totalErrors = 0;

        const { ERROR, OK, WARNING, FILTERED } = totalizers;

        if (ERROR) {
          this.totalErrors = ERROR;
        }
        if (OK) {
          this.totalOkay = OK;
        }
        if (WARNING) {
          this.totalWarnings = WARNING;
        }
      }
    });
    this.total$.subscribe((total) => {
      this._total = 0;
      if (total) this._total = total;
    });
  }

  constructor(private store: Store<AppState>) {}
}
